// ** Reactstrap Imports
import React from 'react';
import { Label, Input, FormFeedback, InputGroupAddon, InputGroup, FormGroup } from 'reactstrap';

const CustomInput = props => {
  const {
    name = '',
    label = '',
    type = 'text',
    defaultValue = null,
    value = null,
    onChange,
    placeholder = 'Enter...',
    invalid = false,
    error = '',
    isInputGroup = false,
    isPrepend = false,
    symbolIcon = null,
    disabled,
    min,
    max,
  } = props;
  return !isInputGroup ? (
    <FormGroup>
      {label && (
        <Label className="form-label" for="invalidState">
          {label}
        </Label>
      )}
      <Input
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        invalid={!!(error || invalid)}
        // defaultValue={value || defaultValue || ''}
        value={value || defaultValue || ''}
        onChange={e => onChange(name, e.target.value)}
        disabled={disabled}
        min={min}
        max={max}
      />
      {error && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>
  ) : (
    <FormGroup>
      {label && (
        <Label className="form-label" for="invalidState">
          {label}
        </Label>
      )}
      <InputGroup>
        {isPrepend && <InputGroupAddon addonType="prepend">{symbolIcon}</InputGroupAddon>}
        <Input
          type={type}
          id={name}
          name={name}
          placeholder={placeholder}
          invalid={!!(error || invalid)}
          defaultValue={value || defaultValue || ''}
          value={value || defaultValue || ''}
          onChange={e => onChange(name, e.target.value)}
        />
        {!isPrepend && <InputGroupAddon addonType="append">&#128269;</InputGroupAddon>}
        {/* {error && <FormFeedback>{error}</FormFeedback>} */}
      </InputGroup>
    </FormGroup>
  );
};
export default CustomInput;
